/* Skapad av Claude Code — Prenumerationssidan, design "Stegen" (godkänd mockup 2026-09-15).
   UI-lager ovanpå paket-motorn window.SvdLpPren (svd-lp-pren.js): addLine/removeLine/commit.
   Renderar storlek som radio-rader, pris, gåvoblock-toggling, engångsköp-slides och paketbaren. */

(function() {
  'use strict';
  if (window.SvdLpPren2026) { return; }
  window.SvdLpPren2026 = true;

  var FREQ_LABEL = { 1: 'varje månad', 2: 'varannan månad', 3: 'var tredje månad' };

  var state = { weight: 1, freq: 1 };
  var giftCtx = null;   // pren-gåvan (läggs vid commit bara när GSO-stack saknas — motorn avgör)
  var cards = {};       // pid -> { el, data, sel }
  var addons = {};      // pid -> { el, data }
  var imgByPid = {};

  function kr(cents) {
    var n = Math.round(cents) / 100;
    var s = n.toFixed(2).replace('.', ',').replace(/,00$/, '');
    var p = s.split(',');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return p.join(',') + ' kr';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function engine() { return window.SvdLpPren || null; }

  /* ==== Storleksval ==== */
  function bundleSel(pid) {
    var c = cards[pid];
    if (c.sel == null) c.sel = 0;
    return c.sel;
  }
  function autoSizeBundle(pid) {
    var c = cards[pid]; var d = c.data;
    var target = state.freq * 30;
    var best = -1, bd = Infinity;
    // Storlekar med erbjudande (GSO-stacken) vinner alltid över de utan: annars landar Hud & Päls
    // på 500 ml (närmast 30 dagar) och kunden ser aldrig gåvorna. Kunden kan byta i raderna.
    var hasOffer = d.rows.some(function(r) { return r.avail !== false && r.gwpVids && r.gwpVids.length; });
    d.rows.forEach(function(r, i) {
      if (r.avail === false) return;
      if (hasOffer && !(r.gwpVids && r.gwpVids.length)) return;
      var days = r.days[state.weight] || 0;
      var diff = Math.abs(days - target);
      if (diff <= bd) { bd = diff; best = i; } // vid lika: större storleken
    });
    if (best === -1) best = 0;
    c.sel = best;
  }

  function rowPrice(r) { return r.planPrices[state.weight] * r.qty; }

  function renderBundle(pid) {
    var c = cards[pid]; var d = c.data;
    var sel = bundleSel(pid);
    var optsEl = c.el.querySelector('[data-opts]');
    if (optsEl) {
      optsEl.innerHTML = d.rows.map(function(r, i) {
        var oos = r.avail === false;
        var on = i === sel && !oos;
        var now = rowPrice(r);
        var cls = 'svd-pg__opt' + (on ? ' is-active' : '') + (oos ? ' is-oos' : '');
        var sub = oos ? 'Slut just nu' : ('Räcker ca ' + (r.days[state.weight] || 0) + ' dagar');
        var tag = (on && r.corner) ? '<span class="svd-pg__opt-tag">' + esc(r.corner) + '</span>' : '';
        var pr = oos ? '<span class="svd-pg__opt-pr">–</span>'
          : '<span class="svd-pg__opt-pr">' + kr(now) + (r.compare > now ? '<s>' + kr(r.compare) + '</s>' : '') + '</span>';
        return '<button type="button" class="' + cls + '" data-size="' + i + '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '"' + (oos ? ' disabled' : '') + '>'
          + '<span class="svd-pg__dot" aria-hidden="true"></span>'
          + '<span><span class="svd-pg__opt-lbl">' + esc(r.label) + '</span>' + tag + '<span class="svd-pg__opt-sub">' + sub + '</span></span>'
          + pr + '</button>';
      }).join('');
    }
    var r = d.rows[sel];
    var osEl = c.el.querySelector('[data-os-stack]');
    if (osEl) osEl.hidden = !(r.gwpVids && r.gwpVids.length);
    var now = rowPrice(r);
    var priceEl = c.el.querySelector('[data-price]');
    if (priceEl) {
      priceEl.innerHTML = '<span class="svd-pg__now">' + kr(now) + '</span>'
        + (r.compare > now ? '<span class="svd-pg__was">' + kr(r.compare) + '</span>' : '')
        + '<span class="svd-pg__per">som prenumerant · ' + FREQ_LABEL[state.freq] + '</span>';
    }
    syncCardButton(pid);
  }

  function addBundle(pid) {
    var c = cards[pid]; var d = c.data;
    var r = d.rows[bundleSel(pid)];
    if (!r || r.avail === false) return;
    var eng = engine(); if (!eng) return;
    eng.addLine(pid, {
      variantId: r.vid, quantity: r.qty, sellingPlanId: r.plans[state.weight], isOneTime: false,
      priceNow: rowPrice(r), priceWas: r.compare,
      title: d.title + ' ' + r.label,
      meta: 'Prenumeration · ' + FREQ_LABEL[state.freq] + ' · ' + d.weights[state.weight],
      gwpVariantId: r.gwpVid || null,
      gwpVariantIds: r.gwpVids || [],
      properties: { '_prenpaket': '1' }
    });
  }

  function addAddon(pid) {
    var a = addons[pid]; if (!a) return;
    var eng = engine(); if (!eng) return;
    eng.addLine(pid, {
      variantId: a.data.vid, quantity: 1, isOneTime: true,
      priceNow: a.data.price, priceWas: a.data.compare || a.data.price,
      title: a.data.title, meta: 'Engångsköp · skickas med paketet',
      properties: { '_prenpaket': '1' }
    });
  }

  function lineOf(pid) {
    var eng = engine(); if (!eng) return null;
    var lines = eng.getState().lines;
    for (var i = 0; i < lines.length; i++) if (lines[i].pid === String(pid)) return lines[i];
    return null;
  }

  function syncCardButton(pid) {
    var c = cards[pid]; if (!c) return;
    var l = lineOf(pid);
    c.el.classList.toggle('is-added', !!l);
    var btn = c.el.querySelector('[data-add="sub"]');
    if (!btn) return;
    var r = c.data.rows[bundleSel(pid)];
    var base = btn.getAttribute('data-label') || btn.textContent.trim();
    if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', base);
    if (r && r.avail === false && !l) { btn.disabled = true; btn.textContent = 'Slut just nu'; btn.classList.remove('is-on'); return; }
    btn.disabled = false;
    btn.classList.toggle('is-on', !!l);
    btn.textContent = l ? 'Tillagd ✓ · ' + kr(l.priceNow) : base + ' · ' + kr(rowPrice(r));
  }

  function syncAddons() {
    Object.keys(addons).forEach(function(pid) {
      var a = addons[pid]; var l = lineOf(pid);
      a.el.classList.toggle('is-added', !!l);
      var b = a.el.querySelector('[data-addon-add]');
      if (b) { b.classList.toggle('is-on', !!l); b.textContent = l ? 'Tillagd ✓' : (b.getAttribute('data-label') || 'Lägg till'); }
    });
  }

  function updateBar(st) {
    var bar = document.querySelector('[data-pren-bar]'); if (!bar) return;
    var lines = st.lines;
    bar.classList.toggle('is-visible', lines.length > 0);
    document.body.style.paddingBottom = lines.length > 0 ? (bar.offsetHeight + 16) + 'px' : '';

    var subs = lines.filter(function(l) { return !l.isOneTime; }).length;
    var once = lines.length - subs;
    var parts = [];
    if (subs) parts.push(subs + (subs === 1 ? ' prenumeration' : ' prenumerationer'));
    if (once) parts.push(once + (once === 1 ? ' engångsköp' : ' engångsköp'));
    var cntEl = bar.querySelector('[data-bar-count]');
    if (cntEl) cntEl.textContent = parts.join(' + ') || '0 produkter';

    var save = st.totals.was - st.totals.now;
    var saveEl = bar.querySelector('[data-bar-save]');
    // "Du sparar 9 kr" (649 mot 658) ser ut som ett skämt — visa besparingen först från 50 kr.
    if (saveEl) { saveEl.hidden = save < 5000; saveEl.textContent = 'Du sparar ' + kr(save); }
    var nowEl = bar.querySelector('[data-co-now]');
    if (nowEl) nowEl.textContent = kr(st.totals.now);
    var wasEl = bar.querySelector('[data-co-was]');
    if (wasEl) { wasEl.hidden = save < 5000; wasEl.textContent = kr(st.totals.was); }

    var goal = 59900;
    var fill = bar.querySelector('[data-meter-fill]');
    if (fill) fill.style.width = Math.min(100, st.totals.now / goal * 100) + '%';
    var mt = bar.querySelector('[data-meter-text]');
    if (mt) {
      if (st.totals.now >= goal) { mt.textContent = 'Fri frakt på din leverans'; mt.classList.add('is-done'); }
      else { mt.textContent = 'Lägg till ' + kr(goal - st.totals.now) + ' till för fri frakt'; mt.classList.remove('is-done'); }
    }

    var list = bar.querySelector('[data-bar-list]');
    if (list) {
      list.innerHTML = lines.map(function(l) {
        var img = imgByPid[l.pid] ? '<img src="' + imgByPid[l.pid] + '" alt="" loading="lazy">' : '';
        return '<div class="svd-pb__item">' + img
          + '<span class="svd-pb__iname">' + esc(l.title) + '<span class="svd-pb__imeta">' + esc(l.meta) + '</span></span>'
          + '<span class="svd-pb__iprice">' + kr(l.priceNow) + '</span>'
          + '<button type="button" class="svd-pb__ix" data-bar-remove="' + l.pid + '" aria-label="Ta bort">×</button></div>';
      }).join('');
    }
  }

  /* ==== Init ==== */
  function init() {
    var grid = document.querySelector('[data-pren-grid]');
    if (!grid) return;
    var bar = document.querySelector('[data-pren-bar]');

    grid.querySelectorAll('[data-bundle]').forEach(function(el) {
      var d;
      try { d = JSON.parse(el.getAttribute('data-bundle')); } catch (e) { return; }
      cards[d.pid] = { el: el, data: d, sel: 0 };
      imgByPid[d.pid] = d.img || '';
      autoSizeBundle(d.pid);
      renderBundle(d.pid);
    });

    // Engångsköp-slides (egen sektion, kan ligga var som helst på sidan)
    document.querySelectorAll('[data-addon]').forEach(function(el) {
      var d;
      try { d = JSON.parse(el.getAttribute('data-addon')); } catch (e) { return; }
      addons[d.pid] = { el: el, data: d };
      imgByPid[d.pid] = d.img || '';
    });

    // Pren-gåvan (utan GSO-stack): registreras som milstolpe, motorn hoppar över den när stack finns
    if (grid.getAttribute('data-gift-enabled') === 'true') {
      var gvid = grid.getAttribute('data-gift-variant');
      var gcode = (grid.getAttribute('data-gift-code') || '').trim();
      if (gvid) {
        giftCtx = { enabled: true, variantId: gvid, code: gcode, img: grid.getAttribute('data-gift-img') || '', title: grid.getAttribute('data-gift-title') || 'din gåva' };
        var eng0 = engine();
        if (eng0) eng0.registerMilestone({ threshold: 1, variantId: gvid, code: gcode, gwp: !gcode, gwpProperty: '_prengava', title: giftCtx.title });
      }
    }

    function setPills(container, activeEl) {
      container.querySelectorAll('.svd-pg__pill').forEach(function(x) {
        var on = x === activeEl;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function refreshAll() {
      Object.keys(cards).forEach(function(pid) {
        autoSizeBundle(pid); renderBundle(pid);
        if (lineOf(pid)) addBundle(pid);
      });
    }
    var wp = grid.querySelector('[data-weight-pills]');
    if (wp) wp.addEventListener('click', function(e) {
      var b = e.target.closest('[data-w]'); if (!b) return;
      setPills(wp, b); state.weight = parseInt(b.getAttribute('data-w'), 10) || 0; refreshAll();
    });
    var fp = grid.querySelector('[data-freq-pills]');
    if (fp) fp.addEventListener('click', function(e) {
      var b = e.target.closest('[data-freq]'); if (!b) return;
      setPills(fp, b); state.freq = parseInt(b.getAttribute('data-freq'), 10) || 1; refreshAll();
    });

    grid.addEventListener('click', function(e) {
      var sz = e.target.closest('[data-size]');
      if (sz) {
        if (sz.disabled) return;
        var bEl = sz.closest('[data-bundle]');
        var pid = JSON.parse(bEl.getAttribute('data-bundle')).pid;
        cards[pid].sel = parseInt(sz.getAttribute('data-size'), 10) || 0;
        renderBundle(pid);
        if (lineOf(pid)) addBundle(pid);
        return;
      }
      var btn = e.target.closest('[data-add]');
      if (btn) {
        var cardEl = btn.closest('[data-bundle]'); if (!cardEl) return;
        var cd = JSON.parse(cardEl.getAttribute('data-bundle'));
        var eng = engine(); if (!eng) return;
        if (lineOf(cd.pid)) { eng.removeLine(cd.pid); return; }
        addBundle(cd.pid);
        return;
      }
      var more = e.target.closest('[data-more]');
      if (more) {
        var mEl = more.closest('[data-bundle]'); if (!mEl) return;
        openPop(JSON.parse(mEl.getAttribute('data-bundle')));
      }
    });

    document.addEventListener('click', function(e) {
      var ab = e.target.closest('[data-addon-add]'); if (!ab) return;
      var aEl = ab.closest('[data-addon]'); if (!aEl) return;
      var pid = JSON.parse(aEl.getAttribute('data-addon')).pid;
      var eng = engine(); if (!eng) return;
      if (lineOf(pid)) eng.removeLine(pid); else addAddon(pid);
    });

    // Läs mer-popup
    var pop = document.querySelector('dialog[data-pren-pop]');
    var popPid = null;
    var popCache = {};
    function fillPopProduct(handle) {
      var c = popCache[handle];
      var descEl = pop.querySelector('[data-pop-desc]');
      var imgEl = pop.querySelector('[data-pop-img]');
      if (descEl && c.desc) descEl.innerHTML = c.desc;
      if (imgEl && c.img) imgEl.src = c.img;
    }
    function loadPopProduct(handle) {
      if (!handle) return;
      if (popCache[handle]) { fillPopProduct(handle); return; }
      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          var first = (p.images && p.images[0]) || p.featured_image || '';
          if (first) first = first + (first.indexOf('?') > -1 ? '&' : '?') + 'width=1080';
          popCache[handle] = { desc: p.description || '', img: first };
          fillPopProduct(handle);
        })
        .catch(function() {});
    }
    function openPop(d) {
      if (!pop) return;
      popPid = d.pid;
      pop.querySelector('[data-pop-img]').src = d.img || '';
      pop.querySelector('[data-pop-name]').textContent = d.title;
      pop.querySelector('[data-pop-desc]').textContent = d.desc || '';
      loadPopProduct(d.handle);
      var r = d.rows[bundleSel(d.pid)];
      var now = rowPrice(r);
      pop.querySelector('[data-pop-price]').innerHTML = '<span class="svd-pg__now">' + esc(r.label) + ' · ' + kr(now) + '</span>'
        + (r.compare > now ? '<span class="svd-pg__was">' + kr(r.compare) + '</span>' : '')
        + '<span class="svd-pg__per">som prenumerant · ' + FREQ_LABEL[state.freq] + '</span>';
      if (typeof pop.showModal === 'function') pop.showModal();
    }
    if (pop) {
      pop.querySelector('[data-pop-close]').addEventListener('click', function() { pop.close(); });
      pop.addEventListener('click', function(e) { if (e.target === pop) pop.close(); });
      pop.querySelector('[data-pop-add]').addEventListener('click', function() {
        if (popPid == null) return;
        addBundle(popPid);
        pop.close();
      });
    }

    // Paketbaren
    if (bar) {
      var toggle = bar.querySelector('[data-bar-toggle]');
      if (toggle) toggle.addEventListener('click', function() { bar.classList.toggle('is-open'); });
      bar.addEventListener('click', function(e) {
        var x = e.target.closest('[data-bar-remove]');
        if (x) { var eng = engine(); if (eng) eng.removeLine(x.getAttribute('data-bar-remove')); }
      });
      var co = bar.querySelector('[data-checkout]');
      if (co) co.addEventListener('click', function() {
        var eng = engine(); if (!eng) return;
        co.disabled = true;
        eng.commit().then(function(res) {
          if (res === null) { co.disabled = false; return; }
          window.location.href = co.getAttribute('data-checkout') || '/cart';
        }).catch(function() { co.disabled = false; });
      });
    }

    window.addEventListener('svd:bundle:update', function(e) {
      Object.keys(cards).forEach(syncCardButton);
      syncAddons();
      updateBar(e.detail.state);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
